import React from 'react';
import { List, Filter, Datagrid, required,
		TextField,  UrlField, NumberField, ReferenceField,
		DateInput } from 'admin-on-rest';
import CHEurField from '../utils/CHEurField';

const GridFilters = (props) => (
    <Filter {...props}>
		<DateInput source="to_date" label="Tot en met datum" alwaysOn options={{
				mode: 'portrait',
				hintText: 'Kies een t/m datum',
				okLabel: 'OK',
				cancelLabel: 'Cancel',
				locale: 'nl'
			}} />
			
		<DateInput source="initialfilter_from_date" label="Van datum" defaultValue={props.date} alwaysOn options={{
				mode: 'portrait',
				hintText: 'Kies een van datum',
				okLabel: 'OK',
				cancelLabel: 'Cancel',
				locale: 'nl',
			}} />
					
    </Filter>
);

export const CustomerGroupedReportList = (props) => (
    <List title="Clicks & omzet per klant" perPage={50} filters={<GridFilters  date={new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(),0,0,0)} />} {...props}>
        <Datagrid >
            <ReferenceField source="user_id" sortable={false} reference="admin/customers" linkType={false} >
				<TextField source="company_name" />
			</ReferenceField>
            <NumberField source="ccount" sortable={false} />
            <CHEurField source="ccost" label="omzet" sortable={false} />			
		</Datagrid>
    </List>
);



// WEBPACK FOOTER //
// ./src/siteclicks/CustomerGroupedReport.js